
// Use this hook if you want to redirect the user to a different URL when they change the landscape.
export default function useLandscapeChangeRedirectUrl(redirectUrlFcn) {

    RivalIQ.curation._setLandscapeChangeRedirectUrl(redirectUrlFcn);

}
